module.exports = __webpack_public_path__ + "static/media/erestoLogoImage.4dce21e2.png";